export default __webpack_public_path__ + "static/media/generic-sensor.9bcdf8a1.jpg";